export default {
  CREATE_SETTING: '/econo/superviseExpiredConfig/save',
  QUERY_TABLE: '/econo/superviseContract/overduelist',
  EXPORT_EXCEL: '/econo/superviseContract/overdueExport',
  GET_HISTORY_SETTING: '/econo/superviseExpiredConfig/query', // 获取历史配置
};
